<template>
  <div id="app">
    <!-- 头部 -->
    <Header :userInfo=userInfo></Header>
    <!-- 侧边导航栏 -->
    <SideNavBar></SideNavBar>
    <Loading></Loading>
    <Notice></Notice>
    <router-view :key="$route.fullPath" />

    <!-- 登录模态框 -->
    <Login></Login>
    <SearchModle></SearchModle>
    <!-- 侧边栏 -->
    <Sidebar></Sidebar>
    <RandomVideo />
    <!-- 底部 -->
    <Footer></Footer>
    <PropGrantPopup />
    <!-- 锁定屏幕 -->
    <LockScreen ref="lockScreen" />
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import SideNavBar from "@/components/layout/SideNavBar.vue";
import Sidebar from '@/components/layout/Sidebar.vue'
import Loading from '@/components/loading/loading.vue'
import Login from '@/components/model/Login.vue'
import SearchModle from '@/components/model/Search.vue'
import Notice from '@/components/notice/Notice.vue'
import RandomVideo from '@/components/RandomVideo/index.vue'
import PropGrantPopup from '@/components/PropGrant/PropGrantPopup.vue'
import LockScreen from '@/components/LockScreen/index.vue'
import { report, getWebSiteInfo, selectUserInfoByToken } from '@/api'
import { getToken, setToken } from '@/utils/cookieUtil'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Sidebar,
    Login,
    SideNavBar,
    SearchModle,
    Loading,
    Notice,
    RandomVideo,
    PropGrantPopup,
    LockScreen
  },
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      isFilterF12: false,
      environment: null
    }
  },
  created() {
    this.getUserInfo()
    this.initWebSiteInfo()
    this.report()
    var that = this

    //监听整个页面的 copy 事件
    document.addEventListener('copy', function (e) {
      let clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;
      let text = window.getSelection().toString();
      if (text) {
        e.preventDefault();
        clipboardData.setData('text/plain', text)
        that.$toast.success("复制成功,转载请务必保留原文链接!")
      }
    })

  },

  methods: {
    initWebSiteInfo() {
      getWebSiteInfo().then(res => {
        this.$store.commit("setWebSiteInfo", res.data)
        this.$store.commit("setVersion", res.data.version)
        this.$store.state.siteAccess = res.extra.siteAccess
        this.$store.state.visitorAccess = res.extra.visitorAccess
        // 添加当日访问量和当日访客量
        this.$store.state.dailySiteAccess = res.extra.dailySiteAccess || 0
        this.$store.state.dailyVisitorAccess = res.extra.dailyVisitorAccess || 0
        this.isFilterF12 = res.data.isFilterF12
        this.environment = res.data.environment
        console.info("是否禁止：" + this.isFilterF12 + "  环境：" + this.environment)
        // 只在生产环境production/development下开启process.env.NODE_ENV === "development"
        if (this.isFilterF12 && process.env.NODE_ENV==this.environment) {
          // 1.禁用右键菜单
          document.oncontextmenu = new Function("event.returnValue=false");
          // 2.禁止键盘F12键
          document.addEventListener("keydown", function (e) {
            if (e.key == "F12") {
              e.preventDefault();
            }
          });

          // 3.禁止进入调试模式
          setInterval(function () {
            check()
          }, 1000);
          var check = function () {
            function doCheck(a) {
              if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
                (function () { }
                    ["constructor"]("debugger")())
              } else {
                (function () { }
                    ["constructor"]("debugger")())
              }
              doCheck(++a)
            }
            try {
              doCheck(0)
            } catch (err) { }
          };
        }
      })

    },
    report() {
      report().then(res => {
        this.$notify({
          title: '欢迎来自 ' + res.data.split("|")[2] + ' 的朋友',
          message: "但愿本博客能够值得你喜欢以及常来",
          type: 'success'
        });
      });
    },
    getUserInfo() {
      let flag = window.location.href.indexOf("token") != -1
      if (flag) {
        let token = window.location.href.split("token=")[1]
        setToken(token)
      }

      // 从cookie中获取token
      let token = getToken()
      if (token != null) {
        selectUserInfoByToken(token).then(res => {
          this.userInfo = res.data
          this.$store.commit("setUserInfo", res.data)
        })
      }
    },
  },

  mounted() {
    let theme = sessionStorage.getItem("theme")
    if (theme == null) {
      theme = "light"
    }
    document.documentElement.dataset.theme = theme
  }
}
</script>

<style lang="scss" scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');
#app {
  background: var(--body-color);
}
</style>
